import { DateTime } from "luxon";

export const TIMEZONE_OPTIONS = [
  { value: "America/New_York", label: "Eastern (ET)" },
  { value: "America/Chicago", label: "Central (CT)" },
  { value: "America/Denver", label: "Mountain (MT)" },
  { value: "America/Los_Angeles", label: "Pacific (PT)" },
  { value: "UTC", label: "UTC" },
];

export const DEFAULT_TIMEZONE = TIMEZONE_OPTIONS[0].value;

export function getInitialTimezone() {
  const browser = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return TIMEZONE_OPTIONS.some((o) => o.value === browser) ? browser : DEFAULT_TIMEZONE;
}

export function formatDate(iso, tz) {
  if (!iso) return "\u2014";
  const dt = tz ? DateTime.fromISO(iso).setZone(tz) : DateTime.fromISO(iso);
  return dt.isValid ? dt.toFormat("LLL dd, yyyy") : iso;
}

export function formatDateTime(iso, tz) {
  if (!iso) return "\u2014";
  const dt = tz ? DateTime.fromISO(iso).setZone(tz) : DateTime.fromISO(iso);
  return dt.isValid ? dt.toFormat("LLL dd, yyyy h:mm a ZZZZ") : iso;
}
